import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Sliders1_Index({ section }) {
  function updateClassBasedOnScreenSize() {
    const element_1 = document.querySelector(".popular-state");
    if (!element_1) return; // Exit if element_1 is not found

    if (window.innerWidth >= 1024) {
      element_1.classList.add("mb-5");
       
    } else {
      element_1.classList.remove("mb-5"); 
    }

    const element_2 = document.querySelector(".index-slider");
    if (!element_2) return; 
    if(element_2){
      if (window.innerWidth >= 1024) {
        element_2.classList.add("exclusive-officer-sec");
         
      } else {
        element_2.classList.remove("exclusive-officer-sec"); 
      }
    }
}

// Run on page load and when resizing
window.addEventListener("load", updateClassBasedOnScreenSize);
window.addEventListener("resize", updateClassBasedOnScreenSize);


  const [isScrolled, setIsScrolled] = useState(false);
  
    const isSlider = section?.is_slider ?? true;
    const itemsPerView = parseInt(section?.items_per_view) || 5;

    const settings = {
      slidesToShow: itemsPerView, 
      slidesToScroll: 1, 
      autoplay: true,
      autoplaySpeed: 2000, 
      arrows: false, 
      dots: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: Math.min(itemsPerView, 5) },
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 },
        },
        {
          breakpoint: 520,
          settings: { slidesToShow: 2 },
        },
      ],
    };
  
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };
  
    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
  
  
      const sliderRef = useRef(null);


  const fallbackItems = [
    { title: 'Hyderabad', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/hyderabad.png' },
    { title: 'Mumbai', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/mumbai.png' },
    { title: 'Manali', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/manali.png' },
    { title: 'Ayodhya', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/ayodhya.png' },
    { title: 'Goa', subtitle: '1527 Properties', image_url: 'assets/img/hotels/states/goa.png' },
  ];
  const items = section?.Items?.length ? section.Items : fallbackItems;

  const renderCard = (item) => {
    const city = String(item.title || '').trim();
    const linkUrl = `/holidays-list?city=${encodeURIComponent(city)}`;

    return (
      <a
        href={linkUrl}
        aria-label={`View holiday packages in ${city || 'this location'}`}
        style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}
      >
        <div className="card">
          <div className="image-content">
            <div className="card-image">
              <img src={item.image_url} alt={item.title || ''} className="card-img" />
            </div>
          </div>
          <div className="card-content">
            <h2 className="properties-title">
              <span className="property-number">{item.subtitle?.split(' ')?.[0] || '1527'}</span> {item.subtitle?.replace(/^\S+\s*/, '') || 'Properties'} <i className="fa fa-arrow-right p-l-6"></i>
            </h2>
          </div>
        </div>
      </a>
    );
  };

  return (
    <div>
    <div className="container offers index-slider">
            <div className="swipper-index popular-state pb-7 pt-0 ">
                <div className="container">
                    <div className="title text-center">
                        <h3 className="pb-0">
                            {section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Find Your Stay </span>}{section?.title || 'in Dream Locations'}
                        </h3>
                    </div>
                </div>
            </div>

            <div className={`customer-logos slides-wrapper ${isSlider ? 'slider' : ''} ${ isScrolled && isSlider ? "slider" : ""}`}>
            {isSlider ? (
              <Slider ref={sliderRef} {...settings}>
                  {items.map((item, index) => (
                    <div key={`${item.title}-${index}`}>
                      {renderCard(item)}
                    </div>
                  ))}
              </Slider>
            ) : (
              <div className="row">
                {items.map((item, index) => {
                  const colWidth = itemsPerView > 0 ? (100 / itemsPerView) : 20;
                  return (
                    <div 
                      key={`${item.title}-${index}`} 
                      className="mb-4"
                      style={{ flex: `0 0 ${colWidth}%`, maxWidth: `${colWidth}%`, padding: '0 15px' }}
                    >
                      {renderCard(item)}
                    </div>
                  );
                })}
              </div>
            )}
        </div>

          
    </div>
    </div>
  );
}

export default Sliders1_Index;
